import { Input } from "antd";
import type { FormItemProps, InputProps } from "antd";
import type { FC } from "react";
import { FormItem } from "./FormItem";

interface FormInputPasswordProps
  extends Omit<FormItemProps, never>,
    Pick<InputProps, "size" | "placeholder" | "prefix"> {
  name: string;
}
export const FormInputPassword: FC<FormInputPasswordProps> = ({
  name,
  label,
  rules,
  size,
  placeholder,
  prefix,
  ...props
}) => {
  return (
    <FormItem name={name} label={label} rules={rules} {...props}>
      <Input.Password size={size} placeholder={placeholder} prefix={prefix} />
    </FormItem>
  );
};
